export default __webpack_public_path__ + "static/media/light_from_scy.a2fa5117.svg";